import styled from 'styled-components';
import Drawer from 'components/Drawer';

export const StyledDrawer = styled(Drawer)`
    width: 600px;

    div[id^=drawer-content] {
        padding: 0;
    }
`;
